const storage = require("./storage")
const navigator = require("./navigator")
const onmessage = require("./onmessage")

class InterfaceLibrary {
    constructor() {
        this.definitions = {}
    }
    get(interfaceName) {
        return this.definitions[interfaceName]
    }
    set(definition) {
        this.definitions[definition.name] = definition
    }
    // Checks if the interface is currently supported or not
    hasSupport(interfaceName) {
        return this.definitions.hasOwnProperty(interfaceName)
    }
}

const interfaceLibrary = new InterfaceLibrary()

interfaceLibrary.set(storage)
interfaceLibrary.set(navigator)
interfaceLibrary.set(onmessage)

module.exports = interfaceLibrary
